var cibMonogram = ["32 32", "<path d='M30.875 0v31.339c0 0.599-0.708 0.891-1.104 0.448l-28.645-31.787zM14.703 17.948l-12.473 13.839c-0.396 0.443-1.104 0.151-1.104-0.448v-31.339z'/>"];

export { cibMonogram };

